import { lazy } from '../../shared/deployment';

export const JMEAddToFavourites = lazy(() => import('./JmeAddToFavourites'));
export { default as GetAllFavourites } from './GetAllFavourites';
